module.exports = ".navbar-brand img {\n  width: 70px; }\n"